const styles = (theme) => ({
  root: {
    display: "inline-block",
  },
  infoDisabled: {
    color: theme.hv.palette.atmosphere.atmo5,
  },
  gutter: {
    padding: theme.hvSpacing(0, 0, "6px", "xs"),
  },
});

export default styles;
